import { render, staticRenderFns } from "./ProjectTeamMembers.vue?vue&type=template&id=ae290d2c&"
import script from "./ProjectTeamMembers.vue?vue&type=script&lang=js&"
export * from "./ProjectTeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTeamMembers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports